<template>
    <div class="companyManagementSearch">
        <Row :gutter="4">
            <Col span="4">
                <Input search v-model="companyNameSearchKey" :placeholder="$t('companyManagement.searchByCompanyName')" @on-search="searchCompanyName()" />
            </Col>
            <Col span="4">
                 <Select v-model="customerType" :placeholder="$t('companyManagement.searchByCustomerType')" @on-change="searchCustomerType()">
                    <Option value="">{{ $t('configuration_management.common.cloudType') }}</Option>
                    <Option :value="item.id" v-for="item in customerTypeList" v-bind:key="item.id">{{item.name}}</Option>
                 </Select>
            </Col>
            <Col span="4">
                <add-company-management></add-company-management>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddCompanyManagement from '../company_management/AddCompanyManagement'
    import TableCompanyManagement from '../company_management/TableCompanyManagement'
    var tableCompanyManagement = TableCompanyManagement;
    export default {
        name: 'CompanyManagementSearch',
        components: {
            AddCompanyManagement
        },
    data () {
        return {
            companyNameSearchKey:'',
            companyName:'',
            customerType:'',
            customerTypeList: []
        }
    },
    mounted() {
          this.getCustomerTypeDropDownBox();
    },
    methods: {
        searchCompanyName: function(){
            eventBus.$emit('companyName', this.companyNameSearchKey);
            tableCompanyManagement.methods.showAll();
        },
        searchCustomerType: function(){
            eventBus.$emit('customerType', this.customerType);
            tableCompanyManagement.methods.showAll();
        },
        // 获取客户类型下拉框
        getCustomerTypeDropDownBox: function() {
            this.customerTypeList = [];
            this.$api.company.getCustomerTypeDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                   this.customerTypeList = res.data;
            })
        }
    }
}
</script>
<style scoped>
    .companyManagementSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/company_management/CompanyManagementSearch.vue